import { lazy } from 'react';

export const SuperAdminAddEditBannerForm = lazy(() => import("./AddEditBanner/index.form"))
export const SuperAdminCMSForm = lazy(() => import("./CMS/index.form"))
export const SuperAdminAddEditFaqForm = lazy(() => import("./Faq/index.form"))
export const SuperAdminProfileForm = lazy(() => import("./Profile/index.form"))